/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-05 14:11:38
 */

import { useState } from "react";
import { Button, Form, Input, message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { Login } from "@/api/interface";
import { getRegisterCode, register } from "@/api/modules/register";

import { ProFormCaptcha } from "@ant-design/pro-components";
import { useDispatch, useSelector } from "react-redux";
import FormLabel from "@/pages/User/components/FormLabel";
import { useTranslation } from "react-i18next";
import { setCurrentUser, setToken } from "@/redux/modules/global/action";
import { getCurrentUser } from "@/api/modules/user";
import { HOME_URL } from "@/config/config";

const RegisterForm = (props: any) => {
	const { setErrorMessage } = props;

	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();

	const { language } = useSelector((state: any) => state.global);
	const dispatch = useDispatch();

	const [loading, setLoading] = useState<boolean>(false);

	const queryParams = new URLSearchParams(location.search);
	const inviteCode = queryParams.get("inviteCode");
	const [form] = Form.useForm();

	// 登录
	const onFinish = async (loginForm: Login.ReqLoginForm) => {
		console.log("loginForm", loginForm);
		try {
			setLoading(true);

			const res = await register({
				...loginForm
			});

			if (res?.code !== 200) {
				// message.error(res?.message);
				setErrorMessage(res.message);
			} else {
				const token = res.data;
				localStorage.setItem("token", token);
				dispatch(setToken(token));

				getCurrentUser().then(res => {
					dispatch(setCurrentUser(res.data));
					localStorage.setItem("nickname", res.data.nickname);

					navigate(HOME_URL);
				});
			}
		} catch (e) {
			setErrorMessage(e?.message);
		} finally {
			setLoading(false);
		}
	};

	const onFinishFailed = (errorInfo: any) => {
		console.log("Failed:", errorInfo);
	};

	const getVerificationCode = async email => {
		console.log("email", email);

		try {
			const params = {
				email: email,
				language: language
			};

			getRegisterCode(params).then(res => {
				console.log("res", res);
				if (res?.code == 200) {
					message.success("Verification code sent");
				}
			});
		} catch (e) {
			message.error("Verification code failed to send");
		}
	};

	return (
		<Form
			form={form}
			name="basic"
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			size="large"
			layout="vertical"
			autoComplete="off"
			initialValues={{ inviteCode: inviteCode }}
		>
			<Form.Item
				label={<FormLabel text={"Username"} />}
				required={false}
				name="userName"
				rules={[
					{
						required: true,
						message: "Please enter your user name!"
					},
					{
						max: 20,
						message: "User name cannot exceed 20 characters"
					}
				]}
			>
				<Input placeholder="your user name" />
			</Form.Item>
			<Form.Item
				label={<FormLabel text={"Email"} />}
				name="email"
				required={false}
				rules={[
					{ required: true, message: "Please enter your email address!" },
					{
						pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
						message: "Please enter a valid email address"
					}
				]}
			>
				<Input placeholder="you@acme.com" />
			</Form.Item>

			<Form.Item
				label={<FormLabel text={"Password"} />}
				name="password"
				required={false}
				rules={[
					{
						required: true,

						message:
							"Password must have at least 8 characters and contain uppercase letter, lowercase letter, numbers and special characters.",
						pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,20}$/
					}
				]}
			>
				<Input.Password autoComplete="new-password" placeholder="your password" />
			</Form.Item>

			<ProFormCaptcha
				captchaProps={{
					size: "large",
					style: {
						width: "40%",
						color: "#FFF",
						backgroundColor: "#565BDD"
					}
				}}
				label={<FormLabel text={"Verification code"} />}
				required={false}
				phoneName="email"
				name="code"
				placeholder={"Enter 6-digit verification code"}
				rules={[
					{
						required: true,
						message: "Please enter the verification code"
					}
				]}
				captchaTextRender={(timing, count) => {
					if (timing) {
						return (
							<div
								style={{
									width: 180,
									opacity: 0.35
								}}
							>
								Resend code ({count})
							</div>
						);
					}
					return "Send verification code";
				}}
				onGetCaptcha={async email => {
					if (!email) {
						message.info("Please enter your email address");
					} else {
						getVerificationCode(email).then(res => {
							if (res?.code === 200) {
								message.success("Verification code sent");
							}
						});
					}
				}}
			/>
			<Form.Item
				label={
					<div>
						<FormLabel text={"Referral code"} />
						<span style={{ fontSize: "1rem", color: "#787878", fontFamily: "PingFang SC" }}> - optional</span>
					</div>
				}
				name="inviteCode"
			>
				<Input />
			</Form.Item>
			<Form.Item>
				<Button className="sign-up-button" htmlType="submit" loading={loading}>
					Sign up
				</Button>
			</Form.Item>
		</Form>
	);
};

export default RegisterForm;
